export const AddToCartErrorNames = {
  cartItemCountLimit: "cartItemCountLimit",
};

export const AddToCartErrorMessages = {
  cartItemCountLimitMessage:
    "You have reached the maximum amount of items for a single order. Please place your order, so you can continue to purchase items on a second separate order.",
};
